import { auth, db } from '../utils/firebaseClient';
import {
  collection, doc, addDoc, getDoc, getDocs,
  updateDoc, deleteDoc, query, where
} from 'firebase/firestore';

const checkDuplicateResponse = (eventId) => {
  return localStorage.getItem(`event_${eventId}_response`);
};

const markResponseSubmitted = (eventId) => {
  localStorage.setItem(`event_${eventId}_response`, 'true');
};

export const createEvent = async (eventData) => {
  const user = auth.currentUser;
  if (!user) throw new Error('User not authenticated');

  const docRef = await addDoc(collection(db, 'dartboard'), {
    title: eventData.name,
    questions: eventData.questions,
    password: eventData.password || null,
    responses: [],
    created_at: new Date().toISOString(),
    user_id: user.uid
  });

  return { id: docRef.id, title: eventData.name, questions: eventData.questions, responses: [] };
};

export const getEvents = async () => {
  const user = auth.currentUser;
  if (!user) throw new Error('User not authenticated');

  const q = query(
    collection(db, 'dartboard'),
    where('user_id', '==', user.uid)
  );
  const snapshot = await getDocs(q);
  const events = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
  return events.sort((a, b) => (b.created_at || '').localeCompare(a.created_at || ''));
};

export const getEvent = async (eventId) => {
  const docRef = doc(db, 'dartboard', eventId);
  const snapshot = await getDoc(docRef);
  if (!snapshot.exists()) throw new Error('Event not found');
  return { id: snapshot.id, ...snapshot.data() };
};

export const deleteEvent = async (eventId) => {
  await deleteDoc(doc(db, 'dartboard', eventId));
  return { success: true };
};

export const addResponse = async (eventId, responses) => {
  if (checkDuplicateResponse(eventId)) {
    throw new Error('You have already responded to this form');
  }

  const event = await getEvent(eventId);
  const currentCount = event.responses ? event.responses.length : 0;

  const responsesWithTimestamp = responses.map(r => ({
    ...r,
    timestamp: new Date().toISOString(),
    responseNumber: currentCount + 1
  }));

  const updatedResponses = [...(event.responses || []), ...responsesWithTimestamp];
  await updateDoc(doc(db, 'dartboard', eventId), { responses: updatedResponses });

  markResponseSubmitted(eventId);
  return { id: eventId, ...event, responses: updatedResponses };
};
